import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const PageReferrerPolicy = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const privatePage = /^\/(?:connect\/instagram|reset-password|bloom\/callback|admin|dashboard|giveaway)(?:\/|$)/.test(pathname);
    if (privatePage) {
      // A public → private SPA transition must stop capture before private
      // asynchronous dashboard data renders; direct loads skip initialization.
      window.posthog?.stopSessionRecording?.();
      window.posthog?.opt_out_capturing?.();
    }
    document.querySelector('meta[name="referrer"]')?.setAttribute(
      'content', privatePage ? 'no-referrer' : 'strict-origin-when-cross-origin',
    );
  }, [pathname]);
  return null;
};